import { createContext, useContext } from 'react'

/**
 * Which form is open over the screen. These are deliberately not routes: a
 * registration opened from the middle of a search should hand the search back
 * untouched when it closes, and a URL swap loses the screen behind it.
 */
export type ModalRequest =
  | {
      kind: 'patient'
      mode: 'create'
      seed?: string | undefined
      /** Where to go once they are registered. Booking an appointment for
       *  somebody new opens this dialog and comes straight back with them
       *  chosen, rather than stranding whoever is on the phone. */
      then?: { kind: 'appointment'; date?: string | undefined } | undefined
    }
  | { kind: 'patient'; mode: 'edit'; patientId: string }
  | { kind: 'caller' }
  | { kind: 'convert'; callerId: string }
  | { kind: 'travel' }
  | { kind: 'appointment'; date?: string | undefined; patientId?: string | undefined }

export interface ModalApi {
  open: (request: ModalRequest) => void
  close: () => void
}

export const ModalContext = createContext<ModalApi | null>(null)

export function useModals(): ModalApi {
  const api = useContext(ModalContext)
  if (!api) throw new Error('useModals must be used inside <ModalProvider>')
  return api
}
